/* Gudsip Kids' Corner games, ported from index18.html. */
/* ===== Kids' Corner: tabs + "Catch the gud" game ===== */
(() => {
  'use strict';
  const GUD = window.GUD;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  if (!$('.kids')) return;

  /* ---------- Tabs ---------- */
  const tabs = $$('[data-ktab]');
  function select(tab, focus) {
    tabs.forEach(t => {
      const on = t === tab;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      if (on && panel.hidden) { panel.hidden = false; panel.classList.remove('is-enter'); void panel.offsetWidth; panel.classList.add('is-enter'); }
      if (!on) panel.hidden = true;
    });
    if (focus) tab.focus();
    GUD.sfx('tick');
    document.dispatchEvent(new CustomEvent('kids:tab', { detail: tab.id }));
  }
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => select(t));
    t.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      select(tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true);
    });
  });

  /* ---------- Catch the gud ---------- */
  const game = $('[data-game]');
  const canvas = $('canvas', game), g = canvas.getContext('2d');
  const scoreEl = $('[data-g-score]'), livesEl = $('[data-g-lives]'), timeEl = $('[data-g-time]'), bestEl = $('[data-g-best]');
  const over = $('[data-g-over]'), titleEl = $('[data-g-title]'), msgEl = $('[data-g-msg]'), startBtn = $('[data-g-start]');
  const mascot = new Image();
  const mascotSrc = ((window.GUDSIP && window.GUDSIP.mascot) || {})[document.body.dataset.flavor === 'chocolate' ? 'chocolate' : 'strawberry'];
  if (mascotSrc) mascot.src = mascotSrc;
  const GOOD = [{ k: 'cube', pts: 10, s: 56 }, { k: 'berry', pts: 5, s: 46 }, { k: 'choco', pts: 5, s: 62 }, { k: 'drop', pts: 5, s: 40 }];
  const GW = 118, GH = 128, ROUND = 30;
  let W = 960, H = 560;
  let playing = false, raf = 0, last = 0, spawnT = 0;
  let items = [], floaters = [], score = 0, lives = 3, timeLeft = ROUND, fill = 0, shake = 0;
  let gx = W / 2, targetX = W / 2;
  const keys = { left: false, right: false };
  let best = Number(GUD.store.get('gudsip-best')) || 0;
  bestEl.textContent = best;

  const cssVar = (n, fb) => getComputedStyle(document.body).getPropertyValue(n).trim() || fb;
  function resize() {
    const r = canvas.getBoundingClientRect();
    if (!r.width) return;
    W = r.width < 620 ? 600 : 960;
    H = Math.round((W * r.height) / r.width);
    canvas.width = Math.round(r.width * Math.min(2, window.devicePixelRatio || 1));
    canvas.height = Math.round(r.height * Math.min(2, window.devicePixelRatio || 1));
    gx = targetX = Math.min(Math.max(gx, GW / 2), W - GW / 2);
    if (!playing) drawIdle();
  }
  if ('ResizeObserver' in window) new ResizeObserver(resize).observe(game); else window.addEventListener('resize', resize);
  window.addEventListener('load', () => { resize(); });

  function poly(pts, col) {
    g.beginPath();
    pts.forEach(([x, y], i) => (i ? g.lineTo(x, y) : g.moveTo(x, y)));
    g.closePath(); g.fillStyle = col; g.fill(); g.stroke();
  }
  function sugarCube(s) {
    const h = s / 2;
    g.lineJoin = 'round'; g.lineWidth = 2.2; g.strokeStyle = '#A99D8F';
    poly([[0, -h], [h, -h / 2], [0, 0], [-h, -h / 2]], '#FFFFFF');
    poly([[-h, -h / 2], [0, 0], [0, h], [-h, h / 2]], '#EEE8E1');
    poly([[h, -h / 2], [0, 0], [0, h], [h, h / 2]], '#DAD2C7');
    g.fillStyle = '#2B1409';
    g.beginPath(); g.arc(-h * 0.62, h * 0.12, 2.6, 0, 7); g.arc(-h * 0.3, h * 0.28, 2.6, 0, 7); g.fill();
    g.strokeStyle = '#2B1409'; g.lineWidth = 2; g.beginPath(); g.moveTo(-h * 0.7, h * 0.52); g.quadraticCurveTo(-h * 0.45, h * 0.38, -h * 0.25, h * 0.62); g.stroke();
    g.fillStyle = '#D91F2E'; g.beginPath(); g.arc(h * 0.72, -h * 0.82, 10, 0, 7); g.fill();
    g.strokeStyle = '#fff'; g.lineWidth = 2.6; g.lineCap = 'round';
    g.beginPath(); g.moveTo(h * 0.72 - 4, -h * 0.82 - 4); g.lineTo(h * 0.72 + 4, -h * 0.82 + 4); g.moveTo(h * 0.72 + 4, -h * 0.82 - 4); g.lineTo(h * 0.72 - 4, -h * 0.82 + 4); g.stroke();
  }
  function background() {
    const grd = g.createLinearGradient(0, 0, 0, H);
    grd.addColorStop(0, '#FFF8EC'); grd.addColorStop(1, cssVar('--f-soft', '#FFE2E0'));
    g.fillStyle = grd; g.fillRect(0, 0, W, H);
    g.fillStyle = 'rgba(43,20,9,.05)';
    for (let y = 22, row = 0; y < H; y += 36, row++) for (let x = 12 + (row % 2) * 18; x < W; x += 36) { g.beginPath(); g.arc(x, y, 2.2, 0, 7); g.fill(); }
    g.fillStyle = 'rgba(43,20,9,.08)'; g.fillRect(0, H - 18, W, 18);
    if (mascot.complete && mascot.naturalWidth) { const mw = W < 700 ? 74 : 96; g.drawImage(mascot, 8, H - 14 - mw * 1.053, mw, mw * 1.053); }
  }
  function glassPath(l, r, top) {
    const inset = 14;
    g.beginPath(); g.moveTo(l, top); g.lineTo(r, top); g.lineTo(r - inset, top + GH - 10);
    g.quadraticCurveTo(r - inset - 1, top + GH, r - inset - 12, top + GH); g.lineTo(l + inset + 12, top + GH);
    g.quadraticCurveTo(l + inset + 1, top + GH, l + inset, top + GH - 10); g.closePath();
  }
  function drawGlass(x) {
    const top = H - 24 - GH, l = x - GW / 2, r = x + GW / 2;
    g.save();
    glassPath(l, r, top); g.fillStyle = 'rgba(255,255,255,.8)'; g.fill();
    g.save(); glassPath(l, r, top); g.clip();
    const lvl = top + GH - (GH - 10) * fill;
    g.fillStyle = cssVar('--f-milk', '#F7B7C0');
    g.beginPath(); g.moveTo(l - 6, lvl);
    for (let i = 0; i <= 8; i++) g.quadraticCurveTo(l - 6 + i * 16 + 8, lvl + (i % 2 ? 5 : -5), l - 6 + (i + 1) * 16, lvl);
    g.lineTo(r + 20, top + GH + 10); g.lineTo(l - 6, top + GH + 10); g.closePath(); g.fill();
    g.restore();
    g.strokeStyle = '#FFC21C'; g.lineWidth = 9; g.lineCap = 'round'; g.lineJoin = 'round';
    g.beginPath(); g.moveTo(x + 16, top + GH - 22); g.lineTo(x + 28, top - 36); g.lineTo(x + 52, top - 48); g.stroke();
    glassPath(l, r, top); g.strokeStyle = '#2B1409'; g.lineWidth = 4.5; g.stroke();
    g.strokeStyle = 'rgba(255,255,255,.85)'; g.lineWidth = 5;
    g.beginPath(); g.moveTo(l + 14, top + 14); g.lineTo(l + 23, top + GH - 20); g.stroke();
    g.restore();
  }
  function drawItem(it) {
    g.save(); g.translate(it.x, it.y); g.rotate(it.rot);
    if (it.k === 'sugar') sugarCube(it.s);
    else { const img = GUD.sprites[it.k], ar = GUD.ratio[it.k]; if (img.complete) g.drawImage(img, -it.s / 2, (-it.s * ar) / 2, it.s, it.s * ar); }
    g.restore();
  }
  function scene() {
    const k = canvas.width / W;
    g.setTransform(k, 0, 0, k, 0, 0);
    g.save();
    if (shake > 0.5) g.translate((Math.random() - 0.5) * shake, (Math.random() - 0.5) * shake);
    background();
    items.forEach(drawItem);
    drawGlass(gx);
    floaters.forEach(f => {
      g.globalAlpha = Math.min(1, f.life / 20);
      g.font = '700 28px "Fredoka", sans-serif'; g.textAlign = 'center';
      g.lineWidth = 6; g.strokeStyle = '#fff'; g.strokeText(f.text, f.x, f.y);
      g.fillStyle = f.c; g.fillText(f.text, f.x, f.y);
      g.globalAlpha = 1;
    });
    g.restore();
  }
  function drawIdle() {
    items = [{ k: 'cube', s: 56, x: W * 0.3, y: H * 0.3, rot: 0.2 }, { k: 'berry', s: 46, x: W * 0.62, y: H * 0.2, rot: -0.3 }, { k: 'sugar', s: 44, x: W * 0.78, y: H * 0.42, rot: 0.1 }, { k: 'drop', s: 40, x: W * 0.46, y: H * 0.48, rot: 0 }];
    scene();
    items = [];
  }
  function hud() {
    scoreEl.textContent = score;
    livesEl.textContent = '♥'.repeat(lives) + '♡'.repeat(3 - lives);
    timeEl.textContent = Math.max(0, Math.ceil(timeLeft));
  }
  function toClient(x, y) {
    const r = canvas.getBoundingClientRect();
    return [r.left + (x / W) * r.width, r.top + (y / H) * r.height];
  }
  function spawn() {
    const elapsed = ROUND - timeLeft;
    const bad = Math.random() < Math.min(0.34, 0.16 + elapsed * 0.006);
    const t = bad ? { k: 'sugar', pts: 0, s: 46 } : GOOD[(Math.random() * GOOD.length) | 0];
    items.push({ ...t, x: 40 + Math.random() * (W - 80), y: -50, vy: (2.6 + Math.random() * 1.6 + elapsed * 0.09) * (H / 560), rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.08 });
  }
  function caught(it) {
    if (it.k === 'sugar') {
      lives--; shake = 14;
      floaters.push({ text: 'No refined sugar!', x: gx, y: H - GH - 60, c: '#D91F2E', life: 50 });
      GUD.sfx('buzz');
    } else {
      score += it.pts; fill = Math.min(1, fill + 0.035);
      floaters.push({ text: '+' + it.pts, x: it.x, y: it.y - 20, c: '#2B1409', life: 40 });
      GUD.sfx('coin');
      const [cx, cy] = toClient(it.x, it.y);
      GUD.burst(cx, cy, 6, 0.5);
    }
    hud();
  }
  function frame(t) {
    const dt = Math.min(50, t - last) / 16.67;
    last = t;
    timeLeft -= (dt * 16.67) / 1000;
    if (keys.left) targetX -= 13 * dt;
    if (keys.right) targetX += 13 * dt;
    targetX = Math.min(Math.max(targetX, GW / 2), W - GW / 2);
    gx += (targetX - gx) * Math.min(1, 0.4 * dt);
    spawnT -= dt * 16.67;
    if (spawnT <= 0) { spawn(); spawnT = Math.max(320, 760 - (ROUND - timeLeft) * 15); }
    const top = H - 24 - GH;
    items = items.filter(it => {
      it.y += it.vy * dt; it.rot += it.vr * dt;
      if (Math.abs(it.x - gx) < GW / 2 - 4 && it.y > top - 14 && it.y < top + 36) { caught(it); return false; }
      return it.y < H + 60;
    });
    floaters = floaters.filter(f => { f.y -= 1.2 * dt; f.life -= dt; return f.life > 0; });
    shake *= 0.88;
    scene();
    if (Math.ceil(timeLeft) !== Number(timeEl.textContent)) hud();
    if (timeLeft <= 0 || lives <= 0) end(); else raf = requestAnimationFrame(frame);
  }
  function start() {
    resize();
    score = 0; lives = 3; timeLeft = ROUND; items = []; floaters = []; fill = 0; spawnT = 300; shake = 0;
    gx = targetX = W / 2;
    playing = true;
    over.hidden = true;
    game.classList.add('is-playing');
    hud();
    GUD.sfx('pop');
    last = performance.now();
    raf = requestAnimationFrame(frame);
  }
  function end(quiet) {
    playing = false;
    cancelAnimationFrame(raf);
    game.classList.remove('is-playing');
    keys.left = keys.right = false;
    const newBest = score > best;
    if (newBest) { best = score; GUD.store.set('gudsip-best', String(best)); bestEl.textContent = best; }
    titleEl.textContent = lives <= 0 ? 'Oops, too much sugar!' : newBest ? 'New high score!' : 'Time’s up!';
    msgEl.textContent = `You scored ${score} points. ` + (newBest ? 'That’s your best ever!' : `Your best is ${best}.`) + ' Ready for another go?';
    startBtn.firstChild.textContent = 'Play again ';
    over.hidden = false;
    hud();
    if (quiet) return;
    if (score > 0) {
      GUD.sfx('win');
      const r = game.getBoundingClientRect();
      GUD.burst(r.left + r.width / 2, r.top + r.height / 2, 40, 1.2);
      if (newBest) GUD.rain(70);
    }
    startBtn.focus({ preventScroll: true });
  }
  startBtn.addEventListener('click', start);
  const setX = e => { const r = canvas.getBoundingClientRect(); targetX = ((e.clientX - r.left) / r.width) * W; };
  game.addEventListener('pointermove', e => { if (playing) setX(e); });
  game.addEventListener('pointerdown', e => { if (playing) setX(e); });
  document.addEventListener('keydown', e => {
    if (!playing) return;
    if (e.key === 'ArrowLeft' || e.key === 'a') { keys.left = true; e.preventDefault(); }
    if (e.key === 'ArrowRight' || e.key === 'd') { keys.right = true; e.preventDefault(); }
  });
  document.addEventListener('keyup', e => {
    if (e.key === 'ArrowLeft' || e.key === 'a') keys.left = false;
    if (e.key === 'ArrowRight' || e.key === 'd') keys.right = false;
  });
  document.addEventListener('kids:tab', e => { if (playing && e.detail !== 'kt-catch') end(true); });
  new MutationObserver(() => { if (!playing) drawIdle(); }).observe(document.body, { attributes: true, attributeFilter: ['data-flavor'] });
  hud();
})();

/* ===== Kids' Corner: "Colour me in" + "Sip it up" ===== */
(() => {
  'use strict';
  const GUD = window.GUD;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const toast = msg => {
    const t = $('.toast');
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-show'), 2800);
  };

  if (!$('.kids')) return;

  /* ---------- Colour me in ---------- */
  const PALETTE = [['Strawberry red', '#E3283B'], ['Milk pink', '#F7A8C0'], ['Sip orange', '#F26A1B'], ['Gud yellow', '#FFC21C'], ['Leaf green', '#54A044'], ['Sky blue', '#59B8F0'], ['Choco brown', '#6B3219'], ['Milk white', '#FFFFFF']];
  const crayons = $('.crayons');
  crayons.setAttribute('role', 'group');
  crayons.innerHTML = PALETTE.map(([name, c], i) =>
    `<button class="crayon" type="button" aria-pressed="${i === 0}" aria-label="${name} crayon" data-c="${c}"><svg viewBox="0 0 40 90" aria-hidden="true"><path d="M20 3L31 26H9Z" fill="${c}" stroke="#2B1409" stroke-width="2.5" stroke-linejoin="round"/><rect x="8" y="24" width="24" height="62" rx="4" fill="${c}" stroke="#2B1409" stroke-width="2.5"/><rect x="8" y="42" width="24" height="24" fill="#fff" opacity=".45"/></svg></button>`
  ).join('');
  let colour = PALETTE[0][1];
  crayons.addEventListener('click', e => {
    const b = e.target.closest('.crayon');
    if (!b) return;
    colour = b.dataset.c;
    $$('.crayon', crayons).forEach(c => c.setAttribute('aria-pressed', String(c === b)));
    GUD.sfx('tick');
  });
  const art = $('[data-colour-svg]');
  const regions = $$('[data-fill]', art);
  art.addEventListener('click', e => {
    const s = e.target.closest('[data-fill]');
    if (!s) return;
    s.setAttribute('fill', colour);
    GUD.sfx('pop');
  });
  $('[data-colour-random]').addEventListener('click', () => {
    regions.forEach((s, i) => setTimeout(() => {
      s.setAttribute('fill', PALETTE[(Math.random() * PALETTE.length) | 0][1]);
      if (i % 3 === 0) GUD.sfx('tick');
    }, i * 55));
  });
  $('[data-colour-clear]').addEventListener('click', () => { regions.forEach(s => s.setAttribute('fill', '#fff')); GUD.sfx('whoosh'); });
  $('[data-colour-save]').addEventListener('click', e => {
    const btn = e.currentTarget;
    const clone = art.cloneNode(true);
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    clone.setAttribute('width', '1280'); clone.setAttribute('height', '880');
    $$('.ln', clone).forEach(n => { n.setAttribute('fill', 'none'); n.setAttribute('stroke', '#2B1409'); n.setAttribute('stroke-width', '4'); n.setAttribute('stroke-linecap', 'round'); n.setAttribute('stroke-linejoin', 'round'); });
    $$('.fl', clone).forEach(n => { n.setAttribute('stroke', '#2B1409'); n.setAttribute('stroke-width', '4'); n.setAttribute('stroke-linejoin', 'round'); });
    const img = new Image();
    img.onload = () => {
      try {
        const c = document.createElement('canvas');
        c.width = 1280; c.height = 980;
        const x = c.getContext('2d');
        x.fillStyle = '#FFF4E2'; x.fillRect(0, 0, c.width, c.height);
        x.drawImage(img, 0, 0, 1280, 880);
        x.fillStyle = '#2B1409'; x.font = '700 40px "Fredoka", sans-serif'; x.textAlign = 'center';
        x.fillText('Coloured with Gudsip · real gud, real goodness', 640, 945);
        const a = document.createElement('a');
        a.download = 'my-gudsip-picture.png';
        a.href = c.toDataURL('image/png');
        document.body.appendChild(a); a.click(); a.remove();
        GUD.sfx('win');
        const r = btn.getBoundingClientRect();
        GUD.burst(r.left + r.width / 2, r.top, 24, 0.9);
        toast('Picture saved! Show it to a grown-up.');
      } catch (err) {
        toast('Sorry, this browser can’t save the picture.');
      }
    };
    img.onerror = () => toast('Sorry, this browser can’t save the picture.');
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(clone));
  });

  /* ---------- Sip it up: hold to drink, finish for a milk moustache ---------- */
  const sipBtn = $('[data-sip]'), level = $('.sip-level'), bubbles = $('.sip-bubbles');
  const meter = $('.sip__meter span'), msg = $('.sip__msg'), face = $('.sip__face');
  const CHEERS = ['Slurp!', 'Glug glug glug!', 'Yum yum!', 'Mmm, gud!', 'Keep sipping!'];
  let amount = 1, holding = false, done = false, refilling = false, sipRaf = 0, lastT = 0, slurpT = 0;
  function render() {
    level.setAttribute('transform', `translate(0 ${((1 - amount) * 240).toFixed(1)})`);
    meter.style.transform = `scaleX(${amount})`;
  }
  function tick(t) {
    const dt = Math.min(50, t - lastT);
    lastT = t;
    if (holding && amount > 0) {
      amount = Math.max(0, amount - dt / 3200);
      slurpT -= dt;
      if (slurpT <= 0) { GUD.sfx('slurp'); slurpT = 240; msg.textContent = CHEERS[(Math.random() * CHEERS.length) | 0]; }
      render();
      if (amount === 0) { finish(); return; }
      sipRaf = requestAnimationFrame(tick);
    } else sipRaf = 0;
  }
  function press() {
    if (refilling) return;
    if (done) { refill(); return; }
    holding = true;
    sipBtn.classList.add('is-held');
    bubbles.setAttribute('opacity', '1');
    lastT = performance.now();
    if (!sipRaf) sipRaf = requestAnimationFrame(tick);
  }
  function release() {
    if (!holding) return;
    holding = false;
    sipBtn.classList.remove('is-held');
    bubbles.setAttribute('opacity', '0');
    if (!done) msg.textContent = `Keep going! ${Math.round(amount * 100)}% left in the glass.`;
  }
  function finish() {
    done = true;
    release();
    sipRaf = 0;
    face.classList.add('has-stache');
    msg.textContent = 'All gone! Milk moustache unlocked!';
    sipBtn.textContent = 'Refill my glass';
    GUD.sfx('win');
    const r = face.getBoundingClientRect();
    GUD.burst(r.left + r.width / 2, r.top + r.height * 0.45, 36, 1.1);
  }
  function refill() {
    refilling = true;
    GUD.sfx('whoosh');
    face.classList.remove('has-stache');
    const from = amount, t0 = performance.now();
    const step = t => {
      const p = Math.min(1, (t - t0) / 1200);
      amount = from + (1 - from) * (1 - Math.pow(1 - p, 3));
      render();
      if (p < 1) requestAnimationFrame(step);
      else { refilling = false; done = false; sipBtn.textContent = 'Hold to sip!'; msg.textContent = 'Fresh glass! Press and hold to drink up.'; }
    };
    requestAnimationFrame(step);
  }
  sipBtn.addEventListener('pointerdown', e => { e.preventDefault(); press(); });
  ['pointerup', 'pointerleave', 'pointercancel'].forEach(ev => sipBtn.addEventListener(ev, release));
  sipBtn.addEventListener('contextmenu', e => e.preventDefault());
  sipBtn.addEventListener('keydown', e => {
    if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); press(); }
    else if (e.key === ' ' || e.key === 'Enter') e.preventDefault();
  });
  sipBtn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); release(); } });
  document.addEventListener('kids:tab', e => { if (e.detail !== 'kt-sip') release(); });
  render();
})();
